import { Box, Typography } from "@mui/material";
import { SxProps } from "@mui/system";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import LockPersonTwoToneIcon from "@mui/icons-material/LockPersonTwoTone";
import EllipsisProgress from "../components/EllipsisProgress";
import { useTimeout } from "../hooks";

interface RedirectingProps {
    url: string;
    name?: string;
    icon?: "locked" | "unlocked";
    delay?: number;
}

const sx: SxProps = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    "& a": {
        color: "secondary.main",
        ":hover": {
            color: "secondary.light",
        },
        ":focus": {
            color: "secondary.light",
        },
        ":active": {
            color: "background.default",
        },
    },
};

export default function Redirecting({ url, name, icon, delay = 2000 }: RedirectingProps) {
    useTimeout(() => window.location.replace(url), delay);

    let iconComponent;

    switch (icon) {
        case "locked":
            iconComponent = <LockPersonTwoToneIcon fontSize="large" />;
            break;
        case "unlocked":
            iconComponent = <LockOpenTwoToneIcon fontSize="large" />;
            break;
        default:
            iconComponent = null;
    }

    return (
        <>
            <Box sx={sx}>
                <Box margin={1}>{iconComponent}</Box>
                <Typography>
                    Redirecting to <a href={url}>{name || url}</a> <EllipsisProgress />
                </Typography>
            </Box>
        </>
    );
}
